var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoContacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.194,
    height: 15.484,
    viewBox: "0 0 14.194 15.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69293",
    "data-name": "Trazado 69293",
    d: "M32.3,0H25.849A3.226,3.226,0,0,0,22.9,1.936h-.919a.645.645,0,1,0,0,1.29h.645v1.29h-.645a.645.645,0,1,0,0,1.29h.645V7.1h-.645a.645.645,0,1,0,0,1.29h.645v1.29h-.645a.645.645,0,1,0,0,1.29h.645v1.29h-.645a.645.645,0,1,0,0,1.29H22.9a3.226,3.226,0,0,0,2.952,1.936H32.3a3.23,3.23,0,0,0,3.226-3.226V3.226A3.23,3.23,0,0,0,32.3,0Zm1.936,12.258A1.936,1.936,0,0,1,32.3,14.194H25.849a1.936,1.936,0,0,1-1.936-1.936V3.226A1.936,1.936,0,0,1,25.849,1.29H32.3a1.936,1.936,0,0,1,1.936,1.936ZM29.075,7.742A1.936,1.936,0,1,0,27.14,5.807,1.936,1.936,0,0,0,29.075,7.742ZM32.3,11.613a.645.645,0,0,1-1.29,0,1.936,1.936,0,1,0-3.871,0,.645.645,0,1,1-1.29,0A3.226,3.226,0,0,1,32.3,11.613Z",
    transform: "translate(-21.333)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoContacto);
export default __webpack_public_path__ + "static/media/Icono-Contacto.9e3a53d36abe474a00ea4b85614dee0d.svg";
export { ForwardRef as ReactComponent };